import i18n from 'i18next'

enum ErrorType {
  UNAUTHORIZED = 'UNAUTHORIZED',
  REMOTE_SERVER_ERROR = 'REMOTE_SERVER_ERROR',
  INITIALIZE_ERROR = 'INITIALIZE_ERROR',
  CHARGE_ERROR = 'CHARGE_ERROR',
  INVALID_REQUEST = 'INVALID_REQUEST',
  NOT_FOUND = 'NOT_FOUND',
  ROUTE_ERROR = 'ROUTE_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  GENERIC = 'GENERIC',
}

class PrisyncError extends Error {
  public readonly statusCode?: number = -1
  public readonly type: ErrorType = ErrorType.GENERIC
  public errorMessage: string = ''

  constructor(
    type?: ErrorType,
    message: string = '',
    displayMessage: string = '',
    statusCode?: number,
  ) {
    super(displayMessage)

    this.name = this.constructor.name
    this.type = type || this.type
    this.errorMessage = message
    this.statusCode = statusCode || this.statusCode

    Object.setPrototypeOf(this, PrisyncError.prototype)

    if (typeof (Error as any).captureStackTrace === 'function') {
      ;(Error as any).captureStackTrace(this, this.constructor)
    }
  }
}

class UnauthorizedError extends PrisyncError {
  constructor(message: string = '', statusCode?: number) {
    const displayMessage = i18n.t(`Prisync.ERRORS.${ErrorType.UNAUTHORIZED}`)
    super(ErrorType.UNAUTHORIZED, message, displayMessage, statusCode)
    this.name = this.constructor.name
  }
}

export { UnauthorizedError, ErrorType, PrisyncError }
